export const defaultTemplateName = "Topaz (2023.0.3)";
export const defaultLinks = {
    b2b: "https://kreator-b2b.comarchesklep.pl/",
    b2c: "https://kreator-b2c.comarchesklep.pl/"
};


// WEBPACK FOOTER //
// ./src/config/defaults.js